import api from '../utils/api'


export const addnewObservacao = async (body) => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;
        const data = await api.post(`/movements/create`, body).then((response) => {
            return response.data;
        });
        return data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Erro ao adicionar observação.");
    }
};


export const getMovementsFromRequest = async (requestId) =>{
    try {
        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const data = await api.get(`/movements/request/${requestId}`).then((response) => {
            return response.data
        })

        return data


    } catch (error) {

        return null
        
    }
}

export const getMovementsFromCollect = async (collectOrderId) =>{
    try {
        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const data = await api.get(`/movements/collect/${collectOrderId}`).then((response) => {
            return response.data
        })

        return data


    } catch (error) {

        return null
        
    }
}

const MovementService = {
    addnewObservacao,
    getMovementsFromRequest,
    getMovementsFromCollect    
  };
  
  export default MovementService;